import { RetailerOptConfigStatusEnum, ConversionType } from '../../gen/api/api';

export const TOOLTIPS = {
    name: 'Name or title of the Currency Conversion configuration.',
    program: 'RM program the Currency Conversion belongs to.',
    participant: 'RM participant sponsoring the Currency Conversion.',
    start: 'Date the Currency Conversion becomes effective in the local time zone.',
    end: 'Date the Currency Conversion is no longer effective in the local time zone.',
    description: 'Long description of the Currency Conversion.',
    status: 'Status of the Currency Conversion. Only Active status will impact display and transaction processing.',
    type: 'Type of the Currency Conversion.',
};

export const ALLOWED_STATUS_TRANSITIONS = new Map([
    [RetailerOptConfigStatusEnum.DRAFT, [RetailerOptConfigStatusEnum.DRAFT, RetailerOptConfigStatusEnum.ENABLED]],
    [RetailerOptConfigStatusEnum.ENABLED, [RetailerOptConfigStatusEnum.ENABLED, RetailerOptConfigStatusEnum.DISABLED]],
    [RetailerOptConfigStatusEnum.DISABLED, [RetailerOptConfigStatusEnum.DISABLED, RetailerOptConfigStatusEnum.DRAFT]],
]);

export const STATUS_LABEL = new Map([
    [RetailerOptConfigStatusEnum.DRAFT, 'Draft'],
    [RetailerOptConfigStatusEnum.ENABLED, 'Active'],
    [RetailerOptConfigStatusEnum.DISABLED, 'Inactive'],
]);

export const TYPE_LABEL = new Map([
    [ConversionType.CURRENCYCONVERSION, 'Currency Conversion'],
    [ConversionType.GROCERPOINTSCONVERSION, 'Grocer Points Conversion'],
    [ConversionType.FISCONVERSION, 'FIS Conversion'],
]);
